import { render, staticRenderFns } from "./popper.vue?vue&type=template&id=3591ba65&scoped=true&"
import script from "./popper.vue?vue&type=script&lang=js&"
export * from "./popper.vue?vue&type=script&lang=js&"
import style0 from "./popper.vue?vue&type=style&index=0&id=3591ba65&lang=scss&scoped=true&"
import style1 from "./popper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3591ba65",
  null
  
)

export default component.exports